class CalculatorStepsController {
  constructor() {
    this.name = 'calculator.steps';
  }

  $onInit(){
    this.pages = [];
    for(let i = 0; i < this.numPages; i++){ this.pages.push(i); }
  }

  /**
   * selects a page from the steps bar. If there are any invalid input fields before the given page, then
   * the transaction to the given page will not occur and will halt unless those required input fields are valid
   * @param index
   */
  setPage(index){
    if(index > 0){

      let isLast = index >= this.pages.length - 1;

      let fields = [];
      this.allPages.map((p,$index) => {
        if($index < index) fields = fields.concat(p.fields);
      });

      // ensure that the fields are valid before going to the desired page
      let invalid = fields.map(f => {
        f.invalid = !f.isValid(fields);
        return f;
      }).reduce((b, f) => {
        return b || f.invalid;
      }, false);

      // only update the index if all of the field inputs prior to the
      // current page of the form are valid and if the link is not the last step
      if(!invalid && !isLast) this.page = index;

    }else{
      this.page = index;
    }

  }

  getStepClass(page){
    let a = '';
    if(page < this.page) a = 'done';
    if(page == this.page) a = 'active';

    if(page + 1 == this.page ) a = a + ' prev';
    if(page + 2 == this.page && this.page == this.pages.length -1 ) a = a + ' prev';

    if(page == this.page + 1 ) a = 'next';
    if(page == this.page + 2 && this.page == 0 ) a = 'next';

    return a;
  }

  /**
   * retrieves the current progress percentage in termns of the current page of the form
   * @returns {number}
   */
  getCurrentProgress(){
    if(this.pages){
      let ind = this.pages.findIndex(x => x === this.page);
      let result = ind > -1 ? (ind+1)/this.pages.length : 0;
      return Math.round(result*100);
    }else{
      return 0;
    }
  }
}

export default CalculatorStepsController;



// WEBPACK FOOTER //
// ./client/app/components/calculator/calculator.steps/calculator.steps.controller.js